import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { dialogActions, dialogTitle, paperProps, secondaryText, title } from './OtpConfirmation.sx';
import OTP from 'app/components/PhoneVerifyModal/OTP';
import SuccessModal from 'app/components/SuccessModal';
import CountdownTimer from 'app/components/CountdownTimer';
import useOtpConfirmation from 'app/components/OtpConfirmation/useOtpConfirmation';
import { useTranslation } from 'react-i18next';
import AsanConfirmation from 'app/components/AsanConfirmation';
interface Props {
  open: boolean;
  close: Dispatch<SetStateAction<boolean>>;
  timerTime?: any;
  phone?: string;
  pathUrl?: any;
  businessKey?: any;
  value?: string;
  headerText?: string;
  inputTitle?: string;
  handleSubmit?: (value: string) => void;
  sendToSignMutation?: (variables: { businessKey: string; data: any }) => void;
  dataToSignMutation?: any;
  error?: any;
}

const OtpConfirmation = (props: Props) => {
  const { open, close, phone, timerTime, sendToSignMutation, businessKey, dataToSignMutation, error } = props;
  const errorText = error?.response?.data?.error?.text;

  const {
    handleSendOtp,
    handleResendOtp,
    handleCancelOtp,
    successModal,
    setSuccessModal,
    unSuccessModal,
    otp,
    setOtp,
    setUnSuccessModal,
    asanModal,
    setAsanModal,
    dataForAsan,
  } = useOtpConfirmation({ sendToSignMutation, dataToSignMutation, businessKey, close });

  const { t } = useTranslation();

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: paperProps,
        }}
        onClose={() => {
          close(false);
          setOtp('');
          handleCancelOtp();
        }}
      >
        <DialogTitle sx={{ ...dialogTitle, mb: '28px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Typography sx={title}>{t('commonTerms.confirmOTP')}</Typography>
            <Typography sx={secondaryText}>
              {t('commonTerms.confirmNumberOTP', {
                number: phone,
              })}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pl: '44px' }}>
          <OTP length={4} setModalOtp={setOtp} />
          <CountdownTimer repeat={handleResendOtp} timerTime={timerTime} errorCase={null} />
          {errorText && (
            <Alert
              sx={{
                mt: 3,
              }}
              severity="error"
            >
              {errorText}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={dialogActions}>
          <Button
            sx={{ width: '100%' }}
            onClick={() => {
              handleSendOtp(otp);
            }}
            disabled={otp.length !== 4}
          >
            {t('commonActions.continue')}
          </Button>
          <Button
            color={'secondary'}
            variant={'outlined'}
            sx={{ ml: '0 !important', width: '100%' }}
            onClick={() => {
              close(false);
              setOtp('');
              handleCancelOtp();
            }}
          >
            {t('commonActions.cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      <SuccessModal
        open={successModal}
        close={setSuccessModal}
        successText={t('commonTerms.paymentSigned')}
        sign={true}
      />
      <SuccessModal
        unsuccess={true}
        open={unSuccessModal}
        close={setUnSuccessModal}
        successText={t('commonTerms.paymentNotSigned')}
      />
      <AsanConfirmation
        title={t('commonTerms.successOperation')}
        redirectUrl="profile/info"
        open={asanModal}
        close={setAsanModal}
        businessKey={dataForAsan?.business_key}
        pathUrl={dataForAsan?.path_url}
        timerTime={dataForAsan?.timer}
        verifyCode={dataForAsan?.verification_code}
      />
    </>
  );
};

export default OtpConfirmation;
